import { reactify } from '@zeiss/zui-react';
export const ZuiIconCommonBattery60Colored = reactify('zui-icon-common-battery-60-colored');
